const state = {
    tagsList: [],
    cacheTags: []
}

const mutations = {
    // 添加当前页面
    ADD_TAG: (state, view) => {
        // 如果已存在 返回
        if (state.tagsList.some(x => x.path === view.path)) return

        // 不存在 添加
        let matched = view.matched || []
        let obj = matched.find(x => x.path === view.path)

        state.tagsList.push(
            Object.assign({}, view, {
                title: view.meta.title || obj.meta.title || 'no-title'
            })
        )
    },
    // 添加缓存页面
    ADD_CACHE_TAGS: (state, view) => {
        if (state.cacheTags.includes(view.name)) return
        
        state.cacheTags.push(view.name)
    },
    // 删除当前页面
    DEL_TAG: (state, view) => {
        let _index = state.tagsList.findIndex(x => x.path === view.path)
        // console.log(_index)
        if (_index > -1) {
            state.tagsList.splice(_index, 1)
        }
    },
    // 删除缓存页面
    DEL_CACHE_TAG: (state, view) => {
        for (const i of state.cacheTags) {
            if (i === view.name) {
                const index = state.cacheTags.indexOf(i)
                state.cacheTags.splice(index, 1)
                break
            }
        }
    },
    // 删除其他tag
    DEL_OTHER_TAG: (state, view) => {
        state.tagsList = state.tagsList.filter(x => {
            return x.name === 'Home' || x.path === view.path
        })
    },
    // 删除其他 缓存tag
    DEL_OTHER_CACHE_TAG: (state, view) => {
        state.cacheTags = state.cacheTags.filter(x => {
            return x === 'Home' || x === view.path
        })
    },
    // 删除全部tag 保留首页
    DEL_ALL_TAG: (state) => {
        state.tagsList = []
    },
    // 删除全部缓存tag 
    DEL_ALL_CACHE_TAG: (state) => {
        state.cacheTags = ['Home']
    }
}

const actions = {
    addView({ commit, rootState }, view) {
        commit('ADD_TAG', view)

        if (rootState.settings.cachePages) {
            if (view.matched && view.matched.length === 3) {
                commit('ADD_CACHE_TAGS', view.matched[1])
            } else {
                commit('ADD_CACHE_TAGS', view)
            }
        }
    },
    delView({ commit, state }, view) {
        return new Promise(resolve => {
            commit('DEL_TAG', view)
            commit('DEL_CACHE_TAG', view)

            resolve({
                tagsList: [...state.tagsList],
                cacheTags: [...state.cacheTags]
            })
        })
    },
    // 删除缓存页面
    delCacheView({ commit, state }, view) {
        return new Promise(resolve => {
            if (view.matched && view.matched.length === 3) {
                commit('DEL_CACHE_TAG', view.matched[1])
            } else {
                commit('DEL_CACHE_TAG', view)
            }
            resolve([...state.cacheTags])
        })
    },
    // 删除 其他tag
    delOtherView({ commit, state }, view) {
        return new Promise(resolve => {
            commit('DEL_OTHER_TAG', view)
            commit('DEL_OTHER_CACHE_TAG', view)

            resolve({
                tagsList: [...state.tagsList],
                cacheTags: [...state.cacheTags]
            })
        })
    },
    delAllViews({ commit, state }, view) {
        return new Promise(resolve => {
            commit('DEL_ALL_TAG')
            commit('DEL_ALL_CACHE_TAG')

            resolve({
                tagsList: [...state.tagsList],
                cacheTags: [...state.cacheTags]
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}